export const COMMENTS_REACTED_QUERY = `
  query CommentsReactedQuery($commentIds: [ID!]!) {
    me {
      commentsReacted(commentIds: $commentIds) {
        commentId
        reacted
      }
    }
  }
`;
